/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SharedFromUser } from "./SharedFromUser";
import {
  SharedFromUserFromJSON,
  SharedFromUserFromJSONTyped,
  SharedFromUserToJSON,
  SharedFromUserToJSONTyped,
} from "./SharedFromUser";
import type { LoyaltyAccount } from "./LoyaltyAccount";
import {
  LoyaltyAccountFromJSON,
  LoyaltyAccountFromJSONTyped,
  LoyaltyAccountToJSON,
  LoyaltyAccountToJSONTyped,
} from "./LoyaltyAccount";
import type { MxRewards } from "./MxRewards";
import {
  MxRewardsFromJSON,
  MxRewardsFromJSONTyped,
  MxRewardsToJSON,
  MxRewardsToJSONTyped,
} from "./MxRewards";

/**
 * Resolved card-program data for one owner; balances and card selection are authoritative.
 * @export
 * @interface CardProgramOwner
 */
export interface CardProgramOwner {
  /**
   *
   * @type {string}
   * @memberof CardProgramOwner
   */
  userId: string;
  /**
   *
   * @type {SharedFromUser}
   * @memberof CardProgramOwner
   */
  sharedFromUser?: SharedFromUser;
  /**
   * Original account metadata and edit identities for this owner and issuer.
   * @type {Array<LoyaltyAccount>}
   * @memberof CardProgramOwner
   */
  accounts: Array<LoyaltyAccount>;
  /**
   *
   * @type {MxRewards}
   * @memberof CardProgramOwner
   */
  rewards: MxRewards;
  /**
   * Distinct manual cards selected by the backend; a stored program balance alone never creates a card.
   * @type {Array<LoyaltyAccount>}
   * @memberof CardProgramOwner
   */
  manualAccounts: Array<LoyaltyAccount>;
}

/**
 * Check if a given object implements the CardProgramOwner interface.
 */
export function instanceOfCardProgramOwner(
  value: object
): value is CardProgramOwner {
  if (!("userId" in value) || value["userId"] === undefined) return false;
  if (!("accounts" in value) || value["accounts"] === undefined) return false;
  if (!("rewards" in value) || value["rewards"] === undefined) return false;
  if (!("manualAccounts" in value) || value["manualAccounts"] === undefined)
    return false;
  return true;
}

export function CardProgramOwnerFromJSON(json: any): CardProgramOwner {
  return CardProgramOwnerFromJSONTyped(json, false);
}

export function CardProgramOwnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CardProgramOwner {
  if (json == null) {
    return json;
  }
  return {
    userId: json["user_id"],
    sharedFromUser:
      json["shared_from_user"] == null
        ? undefined
        : SharedFromUserFromJSON(json["shared_from_user"]),
    accounts: (json["accounts"] as Array<any>).map(LoyaltyAccountFromJSON),
    rewards: MxRewardsFromJSON(json["rewards"]),
    manualAccounts: (json["manual_accounts"] as Array<any>).map(
      LoyaltyAccountFromJSON
    ),
  };
}

export function CardProgramOwnerToJSON(json: any): CardProgramOwner {
  return CardProgramOwnerToJSONTyped(json, false);
}

export function CardProgramOwnerToJSONTyped(
  value?: CardProgramOwner | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    user_id: value["userId"],
    shared_from_user: SharedFromUserToJSON(value["sharedFromUser"]),
    accounts: (value["accounts"] as Array<any>).map(LoyaltyAccountToJSON),
    rewards: MxRewardsToJSON(value["rewards"]),
    manual_accounts: (value["manualAccounts"] as Array<any>).map(
      LoyaltyAccountToJSON
    ),
  };
}
